import { useState } from 'react';
import {
    Box,
    Button,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Checkbox
} from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import FilterListIcon from '@mui/icons-material/FilterList';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

const StatusFilter = ({ status, setStatus, setPage }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const options = [
        'Not started',
        'In progress',
        'Marked complete',
    ];

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const toggleOption = (option) => {
        let updatedStatus;
        if (status.includes(option)) {
            updatedStatus = status.filter(item => item !== option);
        } else {
            updatedStatus = [...status, option];
        }
        setStatus(updatedStatus);
        setPage(0); // Reset to first page
    };

    const getButtonLabel = () => {
        if (status.length === 0) return "All statuses";
        if (status.length === 1) return status[0];
        return status.join(' + ');
    };

    return (
        <Box>
            <Button
                onClick={handleClick}
                startIcon={<FilterListIcon sx={{ color: open || status.length ? '#1A73E8' : '#3b3b3b' }} />}
                endIcon={<ArrowDropDownIcon sx={{ color: open || status.length ? '#1A73E8' : '#3b3b3b' }} />}
                sx={{
                    backgroundColor: open || status.length ? '#E8F0FE' : '#FFF',
                    color: open || status.length ? '#1A73E8' : '#3b3b3b',
                    borderRadius: '36px',
                    boxShadow: 'none',
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: '16px',
                    height: '40px',
                    fontFamily: 'Source Sans Pro',
                    minWidth: '180px',
                    padding: 0,
                    pl: status.length > 0 ? 2 : 0,
                    pr: 1,
                    '&:hover': {
                        boxShadow: 'none',
                    },
                }}
            >
                {getButtonLabel()}
            </Button>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        fontFamily: '"Source Sans Pro", sans-serif',
                        width: 210,
                        boxShadow: '0px 2px 10px rgba(0,0,0,0.1)',
                    }
                }}
                MenuListProps={{ disablePadding: true, fontFamily: 'Source Sans Pro, sans-serif' }}
            >
                {options.map((option) => (
                    <MenuItem
                        key={option}
                        onClick={() => { toggleOption(option); handleClose() }}
                        sx={{
                            height: 42,
                            fontSize: '16px  !important',
                            fontWeight: 400,

                            color: "#3b3b3b",
                            fontFamily: '"Source Sans Pro", sans-serif !important',
                            borderBottom: '1px solid #eee',
                            '&:last-child': { borderBottom: 'none' }
                        }}
                    >
                        <ListItemIcon>
                            {status.includes(option) ? (
                                <CheckBoxIcon color="primary" fontSize="small" sx={{ padding: 0, marginRight: 1, marginLeft: 1.5 }} />
                            ) : (
                                <RadioButtonUncheckedIcon fontSize="small" sx={{ padding: 0, marginRight: 1, marginLeft: 1.5 }} />
                            )}
                        </ListItemIcon>
                        <ListItemText primary={option} />
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
};

export default StatusFilter;
